<template>
  <el-row>
    <el-col :span="spanconfig.treespan">
      <treeselect @fullfortree="spanset('tree')" @treeclose="spanset('normal')" @select="targetchanged">
      </treeselect>
    </el-col>

    <el-col :span="spanconfig.searchspan">
      <searchgroup ref="searchgroup" @searchstatus="spanset"></searchgroup>
    </el-col>

    <el-col :span="spanconfig.utilityspan">
      <el-row type="flex" style="background: #e5e9f2;">
        <el-col>
          <savesearch></savesearch>
        </el-col>
        <el-col>
          <download v-show="$store.state.items.length"></download>
        </el-col>
        <el-col>
          <unshowfields></unshowfields>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>
<script>
import treeselect from "./treeselect";
import searchgroup from "./searchgroup";
import savesearch from "./savesearch";
import download from "./download";
import unshowfields from "./unshowfields"
export default {
  components: {
    treeselect,
    searchgroup,
    savesearch,
    download,
    unshowfields,
  },
  props: [],
  data() {
    return {
      spanconfig: { treespan: 4, searchspan: 16, utilityspan: 4 },
    }
  },
  methods: {
    cellclick() {
      this.$refs.searchgroup.searchboxreset()
    },
    spanset(model) {
      switch (model) {
        case "normal":
          this.spanconfig = { treespan: 4, searchspan: 16, utilityspan: 4 };
          break;
        case "tree":
          this.spanconfig = { treespan: 24, searchspan: 0, utilityspan: 0 };
          break;
        case "search":
          this.spanconfig = { treespan: 2, searchspan: 22, utilityspan: 0 };
          break;
      }
    },

    //select target changing,clean items
    targetchanged(val) {
      this.$axios.clctinitial.clctinitiate(val);
      this.$nextTick(() => {
        this.$refs.searchgroup.resetsearch();
      });

      //   this.popupposition.display = "none";
    },

  }
}
</script>


// WEBPACK FOOTER //
// src/components/presentation/table/table_control.vue